/**
 * Browser-API polyfills — installed before any code that depends on them.
 * Imported first in main.tsx (ES module imports execute in order, so this
 * runs before other modules' top-level and well before runtime use).
 */

// Safari (incl. recent iOS/macOS Safari) does not implement async iteration
// on ReadableStream — there is no ReadableStream.prototype[Symbol.asyncIterator].
// pdfjs-dist v6's getTextContent() builds its result by `for await ... of`-ing
// the stream returned by streamTextContent(), so on Safari it throws
// "undefined is not a function (near '...e of t...')". (mozilla/pdf.js#21557)
// Polyfill the async iterator via the standard reader API.
if (typeof ReadableStream !== 'undefined' && !(Symbol.asyncIterator in ReadableStream.prototype)) {
  Object.defineProperty(ReadableStream.prototype, Symbol.asyncIterator, {
    configurable: true,
    enumerable: false,
    writable: true,
    value: async function* asyncIterator<T>(): AsyncGenerator<Awaited<T>, void, unknown> {
      const reader = (this as ReadableStream<T>).getReader()
      try {
        while (true) {
          const { value, done } = await reader.read()
          if (done) break
          yield value
        }
      } finally {
        reader.releaseLock()
      }
    },
  })
}
